export { default } from './PrivateNoteUGCEditor';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/UGCEditors/PrivateNoteUGCEditor/index.js